import axios from 'axios'
import { NextApiRequest } from 'next'
import { parseCookies } from 'nookies'

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use((request) => {
  const cookies = parseCookies()
  if (cookies.accessToken) {
    request.headers.setAuthorization(`Bearer ${cookies.accessToken}`, true)
  } else {
    delete request.headers.Authorization
  }

  return request
})

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(new Error(error.response?.data?.error))
  },
)

export { axiosInstance }

export const parseRequest = <R>(req: NextApiRequest): R => {
  return typeof req.body === 'string'
    ? JSON.parse(req.body)
    : typeof req.body === 'object' && req.body !== null
    ? req.body
    : {}
}
